import { render, staticRenderFns } from "./FolderSelect.vue?vue&type=template&id=84e73676"
import script from "./FolderSelect.vue?vue&type=script&lang=js"
export * from "./FolderSelect.vue?vue&type=script&lang=js"
import style0 from "./FolderSelect.vue?vue&type=style&index=0&id=84e73676&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports